import styled from 'styled-components';

import { zIndexes } from '../utils/zIndexes';

export const GlobalStyles = styled.div`
  height: 100%;
  width: 100%;
  &&.ant-select-dropdown {
    z-index: ${zIndexes('ANTD_SELECT_DROPDOWN')} !important;
  }

  &&.ant-tooltip {
    z-index: ${zIndexes('ANTD_SELECT_DROPDOWN')} !important;
  }

  &&.ant-drawer {
    z-index: ${zIndexes('ANTD_DRAWER')} !important;
  }

  &&.ant-modal-wrap,
  &&.ant-modal-mask {
    z-index: ${zIndexes('ANTD_DRAWER')} !important;
  }
`;
